import { useCallback, useState } from 'react';

type Theme = 'light' | 'dark';

const getInitialTheme = (): Theme => {
  // Check local storage first
  const savedTheme = localStorage.getItem('theme') as Theme;

  const theme =
    savedTheme ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

  return theme;
};

export const useDarkMode = () => {
  const [theme, setThemeState] = useState<Theme>(getInitialTheme);

  const toggleTheme = useCallback(() => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    const root = window.document.documentElement;
    root.classList.remove(theme);
    root.classList.add(newTheme);
    localStorage.setItem('theme', newTheme);
    setThemeState(newTheme);

    // Trigger a theme change event to update default text colors
    window.dispatchEvent(new CustomEvent('themeChange', { detail: { theme: newTheme } }));
  }, [theme]);

  return { theme, toggleTheme };
};
